import { Avatar } from '../models/avatar.model';
import { Company } from '../models/company';

export enum ActorTypes {
  SUPER = 0,
  USER = 1,
  GUEST = 2,
}

export interface ActorWorkarea {
  id: string;
  logo: string;
  name: string;
}

export interface ActorSettings {
  orderCreation: boolean;
}

export interface Actor {
  avatar: string | Avatar | null;
  companies: any[];
  company: Company | null;
  connection: string | null;
  email: string | null;
  hash: string | null;
  home: string | null;
  id: string | null;
  modules: any;
  name: string | null;
  preferences: any;
  registeredAt: string | null;
  role: any;
  settings: ActorSettings | null;
  type: ActorTypes | null;
  workarea: ActorWorkarea | null;
}
